module.exports = __webpack_public_path__ + "img/tree-4.d88b3e63.png";